import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect } from 'react';
import { useSafeState } from '@beef/react';
export var subscribeEmailTextAgreementDefault = '/shop/sitetext/?key=SHOP_BASKET_SALES_AGREEMENT_POPUP';

/**
 * @desc: Хук для получения текста подписки на рассылку по email
 */

export var useSubscribeEmailTextAgreement = function useSubscribeEmailTextAgreement(url) {
  var _useSafeState = useSafeState(null),
    _useSafeState2 = _slicedToArray(_useSafeState, 2),
    text = _useSafeState2[0],
    setText = _useSafeState2[1];
  useEffect(function () {
    fetch(url || subscribeEmailTextAgreementDefault).then(function (res) {
      if (res.ok) {
        return res.text();
      }
      return null;
    }).then(function (res) {
      return setText(res);
    }).catch(function () {
      // do nothing
    });
  }, [url, setText]);
  return text;
};